<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details">
  <div class="row">
    <div class="col-md-6"></div>
    <div class="col-md-6 truck-owner-header-search">
      <input
        id="truckNumber"
        #newItem
        placeholder="Truck Number Search"
        toUppercase
        appAlphanumericOnly
      />
      <a class="truck-header-search-icon" *ngIf="search_btn">
        <img
          (click)="search(newItem.value)"
          src="../../../assets/img/search.svg"
        />
      </a>
      <a class="truck-header-search-icon" *ngIf="clear_btn">
        <img (click)="resetSearch()" src="../../../assets/img/cross_icon.svg" />
      </a>
    </div>
    <div class="col-md-12">
      <mat-card>
        <div class="trip-acoordion">
          <a
            [ngClass]="{ active: truckType == '-1' }"
            (click)="getTripsList('-1')"
            >All</a
          >
          <a
            [ngClass]="{ active: truckType == 'allocated' }"
            (click)="getTripsList('allocated')"
            >Allocated</a
          >
          <a
            [ngClass]="{ active: truckType == 'available' }"
            (click)="getTripsList('available')"
            >Available</a
          >
          <a
            [ngClass]="{ active: truckType == 'underVerification' }"
            (click)="getTripsList('underVerification')"
            >Under Verification</a
          >
          <a
            [ngClass]="{ active: truckType == 'maintenance' }"
            (click)="getTripsList('maintenance')"
            >Maintenance</a
          >
        </div>
      </mat-card>
    </div>
  </div>
  <button class="add-btn-order" (click)="addTruck()">
    <img src="../../../assets/img/plusIcon.png" alt="" /><span>Add</span>
  </button>

  <div class="truck-owner-items">
    <div class="to_container">
      <div [class.spinner]="loading"></div>

      <div class="row" *ngIf="!trucksArray?.length && !loading">
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <div class="row" *ngIf="trucksArray?.length && !loading">
        <div class="col-sm-6" *ngFor="let item of trucksArray; let i = index">
          <mat-card class="truck-list">
            <div class="row">
              <div class="col-md-5">
                <img
                  src="{{ item.truck_image }}"
                  (click)="viewTruck(item)"
                  class="truck-img"
                />
                <h4>
                  {{ item.truckTypeInfo[0].truck_weight }} ({{
                    item.truckTypeInfo[0].truck_feet
                  }})
                </h4>
                <div class="item-container">
                  <a class="item-delete-btn" (click)="deleteTruck(item._id)"
                    >Delete</a
                  >
                </div>
              </div>
              <div class="col-md-7">
                <div class="item-container">
                  <div class="item-left">Truck No:</div>
                  <div class="item-right">
                    {{ item.truck_number }}
                    <img
                      *ngIf="item?.rc_verified || item?.is_rc_verified || item?.truck_documents_proofs?.rc_verified || item?.truck_documents_proofs?.is_rc_verified"
                      src="../../../assets/img/tick-verify.svg"
                      title="VAHAN Verified"
                      style="width: 14px; height: 14px; margin-left: 4px; vertical-align: middle; margin-top: 0;"
                    />
                  </div>
                </div>
                <div class="item-container">
                  <div class="item-left">Category:</div>
                  <div class="item-right">
                    {{ item.truckCategoryInfo[0].truck_category_name }}
                  </div>
                </div>
                <div class="item-container">
                  <div class="item-left">Driver Contact No:</div>
                  <div class="item-right">
                    {{ item.driverInfo[0]?.mobile }}
                  </div>
                </div>
                <div class="item-container">
                  <div class="item-left">Driver Name:</div>
                  <div class="item-right">
                    {{ item.driverInfo[0]?.username }}
                  </div>
                </div>
                <div class="item-container">
                  <div class="item-left">Recent Trip:</div>
                  <div class="item-right">
                    {{ item.tripBookingInfo?.length ? item.tripBookingInfo[0].trip_id + '-' + item.tripBookingInfo[0].trip_status : 'NA' }}
                  </div>
                </div>
                <!-- <div class="item-container">
                  <a class="item-delete-btn" (click)="deleteTruck(item._id)"
                    >Delete</a
                  >
                </div> -->
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button class="btn" [disabled]="fetch_page == 1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          (click)="pagination('-1')"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button class="btn" [disabled]="fetch_page == 1">
        <img
          src="../../../assets/img/pagination-left.svg"
          (click)="pagination('first')"
          alt=""
          class="btn--icon"
        />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button class="btn" [disabled]="last_page == fetch_page">
        <img
          src="../../../assets/img/pagination-right.svg"
          (click)="pagination('last')"
          alt=""
          class="btn--icon"
        />
      </button>
      <button class="btn" [disabled]="last_page == fetch_page">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          (click)="pagination('1')"
        >
          <path
            stroke-linecap=" round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
